module.exports = __webpack_public_path__ + "img/macbook-mockup_16zu9 2.cba6d8a7.png";